import{SUPPORTED_LOCALES as n}from"../config.js";const l=l=>{const o=l?l.replace("-","_"):null;return n.includes(o)?o:null};export{l as getSupportedLocale};
